




































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Axios from 'axios';
import { SVG, Element } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.panzoom.js';
import IColors from '@/models/colors';
import { IRussiaRegion } from '../models/russia';
import DateSelectorComponent from '@/components/DateSelectorComponent.vue';
import { darkenBy20 } from '../helpers/color-helpers';

@Component({
	components: {
		DateSelectorComponent,
	},
})
export default class RussiaMapComponent extends Vue {

	public loaded = {
		loadSvg: false,
		mounted: false,
	};
	public tooltip = {
		text: '',
		show: false,
		canceled: false,
		x: 0,
		y: 0,
	};

	public get colors(): IColors {
		return this.$store.getters['russia/getColors'];
	}
	public get regions(): IRussiaRegion[] {
		return this.$store.getters['russia/getRegions'];
	}
	public selected: number | undefined = this.selectedRegionId;
	public get selectedRegionId(): number {
		return this.$store.getters['russia/getRegionId'];
	}

	public get summary() {
		return this.$store.getters['russia/getSummary'];
	}

	public hoveredId = '';

	public created() {
		Axios.get('/svg/russia.svg')
			.then((r) => {
				const loadedSvg = new DOMParser()
					.parseFromString(r.data, 'image/svg+xml')
					.getElementsByTagName('svg')[0];
				(this.$refs.svg as SVGElement).outerHTML = loadedSvg.outerHTML;
				this.loaded.loadSvg = true;
			});
	}

	public mounted() {
		this.loaded.mounted = true;
	}

	@Watch('selected')
	private onSelectChange(val: number | undefined, oldVal: number | undefined) {
		if (val === 0) {
			this.selected = -1;
		}
		if (val !== undefined && val >= 0) {
			const region = this.regions.find((r) => r.code === val);
			this.$store.dispatch('russia/updateRegionId', region!.code);
		} else {
			this.$store.dispatch('russia/updateRegionId', -1);
		}
	}

	@Watch('regions', { deep: true })
	private onChangeCodes() {
		if (this.loaded.loadSvg && this.loaded.mounted) {
			document.querySelectorAll('#russiamap svg path, #russiamap svg polygon').forEach((v) => {
				const region = this.regions.find((d) => d.code + '' === v.id);
				if (region && region.isolatedTwoWeek !== 0) {
					if (+v.id !== this.selectedRegionId) {
						v.setAttribute('fill', this.colors.default);
					}
				} else {
					v.setAttribute('fill', this.colors.nodata);
				}
				v.setAttribute('stroke', this.colors.border);
			});
		}
	}

	@Watch('loaded', { deep: true })
	private onLoadChanged(
		val: ({ loadSvg: boolean, mounted: boolean }),
		oldVal: ({ loadSvg: boolean, mounted: boolean })) {
		if (val.loadSvg && val.mounted) {
			document.querySelectorAll('#russiamap svg path, #russiamap svg polygon').forEach((v) => {
				const region = this.regions.find((d) => d.code + '' === v.id);
				if (region && region.isolatedTwoWeek !== 0) {
					v.setAttribute('fill', this.colors.default);
				} else {
					v.setAttribute('fill', this.colors.nodata);
				}
				v.setAttribute('stroke', this.colors.border);
			});
			const svg = document
				.getElementById('russiamap')!
				.getElementsByTagName('svg')[0];
			svg.addEventListener('mouseover', this.onMouseOver);
			svg.addEventListener('mouseout', this.onMouseOut);
			svg.addEventListener('click', this.onClick);
			(SVG('#russiamap svg') as any).panZoom({ zoomFactor: 0.15, zoomMin: 0.932, zoomMax: 4 });
		}
	}


	private onMouseOver(event: MouseEvent) {
		if (event.target &&
			((event.target as HTMLElement).tagName === 'path' ||
				(event.target as HTMLElement).tagName === 'polygon')) {
			const targetElem = event.target as HTMLElement;
			const district = this.regions.find((d) => d.code + '' === targetElem.id);
			if (district) {
				this.hoveredId = targetElem.id;
				this.tooltip.canceled = false;
				this.tooltip.x = event.x;
				this.tooltip.y = event.y;
				this.tooltip.text = district.name;
			} else {
				this.setTooltipCanceled();
			}
		} else if (event.target && ((event.target as HTMLElement).tagName === 'svg')) {
			this.setTooltipCanceled();
		}
	}

	private onClick(event: Event) {
		if (event.target &&
			((event.target as HTMLElement).tagName === 'path' ||
				(event.target as HTMLElement).tagName === 'polygon')) {
			const targetElem = event.target as HTMLElement;
			const district = this.regions.find((d) => d.code + '' === targetElem.id);
			if (district) {
				if (this.selectedRegionId === +targetElem.id) {
					this.$store.dispatch('russia/updateRegionId', -1);
				} else {
					this.$store.dispatch('russia/updateRegionId', +targetElem.id);
				}
			}
		} else if (event.target && (event.target as HTMLElement).tagName === 'svg') {
			this.$store.dispatch('russia/updateRegionId', -1);
		}

	}

	private onMouseOut(event: MouseEvent) {
		this.hoveredId = '';
	}

	@Watch('selectedRegionId')
	private onDistrictChange(val: number, oldVal: number) {
		this.selected = this.selectedRegionId;
		const svgObj = SVG('#russiamap svg');
		const paths = svgObj
			.find('path,polygon')
			.forEach((p) => {
				const regionData = this.regions.find(r => r.code === +p.id());
				const hasData = regionData !== undefined ? regionData.isolatedTwoWeek !== 0 : false;
				if (+p.id() === val) {
					p.attr({ fill: darkenBy20(hasData ? this.colors.hover : this.colors.nodata) });
				} else {
					p.attr({ fill: hasData ? this.colors.default : this.colors.nodata });
				}
			});
	}

	@Watch('hoveredId')
	private onCountryHover(val: string, oldVal: string) {
		const svgObj = SVG('#russiamap svg');
		const paths = svgObj
			.find('path,polygon')
			.forEach((p) => {
				const currentColor = p.fill();
				if (+p.id() === +val) {
					if (currentColor === this.colors.default) {
						p.attr({ fill: this.colors.hover });
						this.tooltip.show = true;
					}
				} else {
					if (currentColor === this.colors.hover) {
						p.attr({ fill: this.colors.default });
					}
				}
			});

	}

	private setTooltipCanceled() {
		this.tooltip.canceled = true;
		setTimeout(() => {
			if (this.tooltip.canceled) {
				this.tooltip.show = false;
			}
		}, 100);
	}
}
